import { DisclosureHost } from "@/hooks/use-disclosure";
import { SignedNoteSummary } from "@/pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/note-preview";

export interface ViewEncounterSummaryDrawerProps {
  /** Opened with the appointment id: `disclosure.open(appointmentId)`. */
  disclosure: DisclosureHost;
  onClose?: () => void;
}

/**
 * The one "View Visit Note" entry point for scheduling, billing and reports:
 * Premier MD notes open the report preview, other notes the legacy PDF drawer.
 */
const ViewEncounterSummaryDrawer = ({
  disclosure,
  onClose,
}: ViewEncounterSummaryDrawerProps) => (
  <SignedNoteSummary disclosure={disclosure} onClose={onClose} />
);

export default ViewEncounterSummaryDrawer;
